import {
  AmazonS3ConnectionContext,
  type IAmazonS3ConnectionContext,
} from "@via/context/amazon-s3-connection-context.tsx";
import { useContext } from "react";

export function useAmazonS3Connection(): IAmazonS3ConnectionContext {
  return useContext(AmazonS3ConnectionContext);
}
